import { IRequestPaginationData } from '../../indigofair/data/IRequestPaginationData';

export namespace IQueryFlashSalesRequest {
  /**
   * Identifying source sent from clients, used to decide if clearance should be returned
   */
  export enum SearchSource {
    LANDING_PAGE = 'LANDING_PAGE',
    CAROUSEL = 'CAROUSEL',
    SEASONAL_SALE = 'SEASONAL_SALE',
  }

  /**
   * Return an instance of IQueryFlashSalesRequest with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (
    partial?: Partial<IQueryFlashSalesRequest>
  ): IQueryFlashSalesRequest =>
    ({
      filter_keys: [],
      ...(partial ?? {}),
    }) as IQueryFlashSalesRequest;
}

/**
 * Search request object V2 containing all relevant info from the frontend (i.e. query text, filters)
 * Encodes applied filters in a list of filterKeys
 */
export interface IQueryFlashSalesRequest {
  query: string | undefined;
  /**
   * Use paginationData instead of top level pageNumber and pageSize
   * @deprecated
   */
  page_number: number | undefined;
  /**
   * @deprecated
   */
  page_size: number | undefined;
  filter_keys: Array<string>;
  return_filter_sections: boolean | undefined;
  source: keyof typeof IQueryFlashSalesRequest.SearchSource | undefined;
  /**
   * See ClickInfo.containerName.
   */
  container_name: string | undefined;
  pagination_data: IRequestPaginationData | undefined;
}
